module.exports = __webpack_public_path__ + "static/media/ios-arrow-dropleft.ebff291c.svg";